import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  // Divider,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";
import * as XLSX from "xlsx";
// import AppConfig from "appConfig";
// import { useAuthUser } from "react-auth-kit";

function Products() {
  const pageTitle = "Product Inventory";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  // const auth = useAuthUser();
  // const accountInfo = auth();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  let currency = "";
  const [products, setProducts] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [productTitle, setProductTitle] = useState(null);
  const [productSKU, setProductSKU] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  const [productAttributes, setProductAttributes] = useState("[]");
  const [productAmount, setProductAmount] = useState(null);
  const [productDispenseQty, setProductDispenseQty] = useState(1);
  const [uploadFile, setUploadFile] = useState(null);
  const [openNewProductDialog, setOpenNewProductDialog] = useState(false);
  const [openUploadProductItemsDialog, setOpenUploadProductItemsDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Product Transfer
  const [openProductItemTransfer, setOpenProductItemTransferDialog] = useState(false);
  const [destinationCampaign, setDestinationCampaign] = useState(null);
  const [transferPrice, setTransferPrice] = useState(null);
  const [transferQty, setTransferQty] = useState(0);

  const [openProductItemGenerate, setOpenProductItemGenerate] = useState(false);
  const [productItemGenerateQty, setProductItemGenerateQty] = useState(100);

  const [openUploadProductsDialog, setOpenUploadProductsDialog] = useState(false);

  function downloadTemplate(headers, filename = "sample_upload.xlsx") {
    const worksheet = XLSX.utils.aoa_to_sheet([headers]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
    XLSX.writeFile(workbook, filename);
  }

  async function updateProductStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/products/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteProduct(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/products/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const productTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Price", accessor: "price", align: "left" },
    { Header: "SKU", accessor: "sku", align: "left" },
    // { Header: "Fields", accessor: "fields", align: "left" },
    // { Header: "Items", accessor: "items", align: "left" },
    { Header: "Managed", accessor: "inventory", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildProductRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        sku: row.sku,
        price: `${currency}${(row.price / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        inventory: (
          <MDBox>
            <Icon color={row.managed_inventory ? "success" : "error"}>
              {row.managed_inventory ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Manage Product">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  navigate(`/products/${row.reference}`);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>settings</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title={`${row.status ? "Disable" : "Enable"} product`}>
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(`${row.status ? "Disable" : "Enable"} this product?`) === true
                  ) {
                    updateProductStatus(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  {row.status ? "pause" : "play_arrow"}
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Attach To Campaign">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  setTransferQty(0);
                  setTransferPrice(row.price / 100);
                  setDestinationCampaign(null);
                  setSelectedProduct(row.reference);
                  // setProductSource(row.source);
                  setOpenProductItemTransferDialog(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>move_up</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete product?`) === true) {
                  deleteProduct(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/products.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaigns(result.data.data.campaigns);

            currency = result.data.data.currency;
            const pArows = buildProductRows(result.data.data.products);
            setProducts(pArows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createProduct() {
    if (productTitle === null) {
      setSeverity("error");
      setErrMsg("Product name is required.");
      setOpen(true);
      return;
    }

    if (productDescription === null) {
      setSeverity("error");
      setErrMsg("Product description is required.");
      setOpen(true);
      return;
    }

    if (productAmount === null) {
      setSeverity("error");
      setErrMsg("Product price is required.");
      setOpen(true);
      return;
    }

    if (parseInt(productDispenseQty, 10) <= 0) {
      setSeverity("error");
      setErrMsg("Item per customer quantity is required.");
      setOpen(true);
      return;
    }

    setOpenNewProductDialog(false);
    setShowLoading(true);
    const json = {
      title: `${productTitle}`,
      description: `${productDescription}`,
      attributes: productAttributes,
      price: productAmount * 100,
      sku: productSKU,
    };

    await axios
      .post("portal/products/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function postProductObjects(formData) {
    setShowLoading(true);
    await axios
      .post("portal/products/objects/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Upload successful.");
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadProductObjects = () => {
    if (selectedProduct === null) {
      setSeverity("error");
      setErrMsg("Please select a product.");
      setOpen(true);
      setShowLoading(false);
    }

    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("product", selectedProduct);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadProductItemsDialog(false);
    setShowLoading(true);

    postProductObjects(formData);
  };

  function fileSelected(e, any = false) {
    e.persist();
    if (!any) {
      const fileTypes = ["xlsx", "xls", "csv"];
      const file = e.target.files[0];
      const extension = file.name.split(".").pop().toLowerCase();
      const supported = fileTypes.indexOf(extension) > -1;
      if (!supported) {
        setSeverity("error");
        setErrMsg("Only excel and csv files accepted.");
        setOpen(true);
        return;
      }
    }

    setUploadFile(e.target.files[0]);
  }

  async function transferProductObjects() {
    if (selectedProduct === null) {
      setSeverity("error");
      setErrMsg("Please select a product.");
      setOpen(true);
      setShowLoading(false);
    }

    if (destinationCampaign === null) {
      setSeverity("error");
      setErrMsg("Destination campaign is required");
      setOpen(true);
      return;
    }

    if (transferQty === null || transferQty < 0) {
      setSeverity("error");
      setErrMsg("Quantity is required");
      setOpen(true);
      return;
    }

    setOpenProductItemTransferDialog(false);
    setShowLoading(true);

    const json = {
      from: selectedProduct,
      to: destinationCampaign,
      price: transferPrice * 100,
      quantity: transferQty,
    };

    await axios
      .post("portal/products/transfer.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function generateProductItems() {
    if (parseInt(productItemGenerateQty, 10) <= 0) {
      setSeverity("error");
      setErrMsg("Quantity is required.");
      setOpen(true);
      return;
    }

    setOpenProductItemGenerate(false);
    setShowLoading(true);
    const json = {
      product: selectedProduct,
      quantity: productItemGenerateQty,
    };

    await axios
      .post("portal/products/objects/generate.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function uploadProducts() {
    if (!uploadFile) {
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadProductsDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/products/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openUploadProductsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Products</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1} mb={3}>
            <MDBox>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
            </MDBox>
            <MDBox mt={3}>
              <Alert severity="warning">
                <MDTypography variant="subtitle2" fontSize={14} mb={1}>
                  Download sample upload template.
                </MDTypography>
                <MDButton
                  size="small"
                  variant="contained"
                  color="dark"
                  onClick={() => {
                    let headers = ["name", "sku", "description", "price", "images"];
                    downloadTemplate(headers, "product_upload.xlsx");
                  }}
                >
                  Sample Template
                </MDButton>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadProductsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              uploadProducts();
            }}
          >
            Upload
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewProductDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>New Product</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                placeholder="Product Name"
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setProductTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                placeholder="Product SKU..."
                name="title"
                margin="dense"
                label="SKU (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setProductSKU(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                multiline
                minRows={3}
                name="description"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                placeholder="Comprehensive description displayed to customers."
                onChange={(e) => setProductDescription(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="price"
                margin="dense"
                label="Price"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setProductAmount(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewProductDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createProduct();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadProductItemsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Product Items</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={4}>
              <TextField
                fullWidth
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
            <MDBox mt={4} align="right">
              <MDButton
                variant="contained"
                color="dark"
                size="small"
                onClick={() => {
                  setOpenUploadProductItemsDialog(false);
                  setOpenProductItemGenerate(true);
                }}
              >
                Auto-Generate Items?
              </MDButton>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadProductItemsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadProductObjects();
            }}
          >
            Upload Items
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openProductItemGenerate} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Generate Product Items</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                margin="dense"
                label="Quantity"
                type="number"
                fullWidth
                variant="outlined"
                value={productItemGenerateQty}
                onChange={(e) => setProductItemGenerateQty(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenProductItemGenerate(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              generateProductItems();
            }}
          >
            Generate
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openProductItemTransfer} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Product To Campaign</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Destination Campaign</InputLabel>
                <Select
                  label="Destination Campaign"
                  onChange={(e) => {
                    setDestinationCampaign(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      campaigns.map((record) => (
                        <MenuItem value={record.reference}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                value={transferPrice}
                name="transferPrice"
                margin="dense"
                label="Price"
                type="decimal"
                fullWidth
                variant="outlined"
                onChange={(e) => setTransferPrice(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={transferQty}
                name="transferQty"
                margin="dense"
                label="Quantity"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTransferQty(e.target.value)}
              />
              <MDTypography px={1} variant="h6" fontSize={13} fontWeight="light" mt={1}>
                <Icon color="info">info</Icon>&nbsp;Note: If product is already attached, the
                quantity will be updated.
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenProductItemTransferDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              transferProductObjects();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>inventory</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Product Inventory
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={14}>
                        Create and manage your products. Keep track of stock, quantity and price.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3} mb={3} display="flex" justifyContent="center" gap={1}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setProductTitle(null);
                          setProductAttributes(null);
                          setProductDispenseQty(1);
                          setProductAmount(null);
                          // setProductSource(null);
                          setOpenNewProductDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Create
                      </MDButton>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setUploadFile(null);
                          setOpenUploadProductsDialog(true);
                        }}
                        startIcon={<Icon>upload</Icon>}
                      >
                        Upload
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            {products.length > 0 && (
              <MDBox mt={5}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Products
                        </MDTypography>
                        {/* <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <MDBox>
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setProductTitle(null);
                                setProductAttributes(null);
                                setProductDispenseQty(1);
                                setProductAmount(null);
                                // setProductSource(null);
                                setOpenNewProductDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </MDBox>
                        </MDBox> */}
                      </MDBox>
                    </MDBox>
                    <MDBox p={0}>
                      <DataTable
                        table={{ columns: productTableColumns, rows: products }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Products;
